import axios from 'axios';

const state = {
    tickets: [],
    currentTicket: null,
    currentMessages: [],
    unreadCount: 0,
    workingHours: { is_open: true, info: '', next_open_at: 0 },
};

const getters = {
    supportTicketUnread: s => s.unreadCount,
    supportWorkingHours: s => s.workingHours,
};

const actions = {
    support_ticket_working_hours({ commit }) {
        return axios.get('support-tickets/working-hours').then(r => {
            commit('SET_SUPPORT_WORKING_HOURS', r.data.data);
            return r;
        });
    },
    support_ticket_unread_count({ commit }) {
        return axios.get('support-tickets/unread-count').then(r => {
            commit('SET_SUPPORT_UNREAD', r.data.data.unread_count || 0);
            return r;
        });
    },
    support_ticket_list({ commit }, params) {
        return axios.get('support-tickets', { params: params || {} }).then(r => {
            commit('SET_SUPPORT_TICKETS', r.data.data.tickets || []);
            return r;
        });
    },
    support_ticket_detail({ commit }, id) {
        return axios.get('support-tickets/' + id).then(r => {
            commit('SET_SUPPORT_CURRENT', { ticket: r.data.data.ticket, messages: r.data.data.messages });
            // Mark unread reset locally
            commit('SET_SUPPORT_UNREAD', Math.max(0, (state.unreadCount || 0) - (r.data.data.ticket?.user_unread_count || 0)));
            return r;
        });
    },
    support_ticket_create(_, formData) {
        return axios.post('support-tickets', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
    support_ticket_reply(_, { id, formData }) {
        return axios.post('support-tickets/' + id + '/reply', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
    support_ticket_close(_, id) {
        return axios.put('support-tickets/' + id + '/close');
    },
};

const mutations = {
    SET_SUPPORT_WORKING_HOURS(state, data) { state.workingHours = data; },
    SET_SUPPORT_UNREAD(state, n) { state.unreadCount = n; },
    SET_SUPPORT_TICKETS(state, list) { state.tickets = list; },
    SET_SUPPORT_CURRENT(state, { ticket, messages }) {
        state.currentTicket = ticket;
        state.currentMessages = messages || [];
    },
    APPEND_SUPPORT_MESSAGE(state, msg) { state.currentMessages.push(msg); },
};

export default { state, getters, actions, mutations };
